import {
  MutationCache,
  QueryCache,
  QueryClient,
} from '@tanstack/react-query'
import { logger } from '@/lib/logger'

/** Shared TanStack Query defaults + error logging (used by `QueryProvider`). */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError(error, query) {
        logger.error('Query failed', {
          err: error,
          queryKey: query.queryKey as unknown as string,
        })
      },
    }),
    mutationCache: new MutationCache({
      onError(error, _variables, _context, mutation) {
        logger.error('Mutation failed', {
          err: error,
          mutationKey: mutation.options.mutationKey as unknown as string,
        })
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  })
}
